﻿import { FormInput, FormSelect, GridView, MasterDetailForm, SimpleView, Widget } from '@digital/ui';
import React, { useState, useEffect } from 'react';
import { Collapse, Icon } from 'antd';

const DirecionarRevisoes = () => {

    const { Panel } = Collapse;

    return (

        <SimpleView>

            <GridView noform>

                <Collapse
                    key="direcionarRevisoes"
                    bordered={false}
                    expandIcon={() => <Icon type="arrows-right_4" />}
                    defaultActiveKey={'direcionarRevisoes'}
                >
                    <Panel
                        key="direcionarRevisoes"
                        header="REDIRECIONAMENTO DE REVISÃO DE MINUTA"
                    >
                        <MasterDetailForm initialValues={{ situacoesId: ['0', '1'] }}  >
                            <FormInput label="Número / Ano" name="NumeroAno" span={6} />
                            <FormInput label="Fornecedor" name="Fornecedor" span={6} />
                            <FormSelect
                                mode="multiple"
                                label="Tipo da Minuta"
                                name="respostaTipoDaMinuta"
                                span={6}
                            />
                            <FormSelect
                                mode="multiple"
                                label="Área Solicitante"
                                name="AreaSolicitante"
                                span={6}
                            />
                            <FormInput label="Descrição da Minuta" name="DescricaoDaMinuta" span={3} />
                            <FormInput label="Status da Minuta" name="StatusDaMinuta" span={3} />
                        </MasterDetailForm>
                    </Panel>
                </Collapse>
            </GridView>
        </SimpleView>
    );

};


export default DirecionarRevisoes;